<template>
  <v-container>
    <div v-if="!practiceTestComplete">
      <app-test-question
        :questionDetails="questionDetails"
        :totalQuestions="totalQuestions"
        :displayAlert="displayAlert"
        :messageText="messageText"
        @onAnswerChanged="onAnswerChanged"
      ></app-test-question>
      <v-layout class="mx-auto mt-5">
        <v-flex sm3 class="mr-5" v-if="showSkipQuestion">
          <v-btn color="primary" @click="onSkipQuestion">
            <span class="controlled-font white--text">{{
              siteText.ui.skipQuestion
            }}</span>
            <v-icon right color="white"> mdi-share-outline </v-icon>
          </v-btn>
        </v-flex>
        <v-flex sm3 class="mx-5">
          <v-btn
            v-if="!displayAlert"
            :disabled="firstQuestion"
            @click="onPreviousQuestion"
            class="controlled-font"
            color="primary"
          >
            <v-icon left>
              mdi-arrow-left-bold
            </v-icon>
            {{ siteText.ui.previous }}
          </v-btn>
        </v-flex>
        <v-flex sm3 class="mx-5">
          <v-btn
            v-if="!displayAlert"
            :disabled="lastQuestion || this.answerRequired"
            @click="onNextQuestion"
            class="primary controlled-font"
            >{{ siteText.ui.next }}
            <v-icon right>
              mdi-arrow-right-bold
            </v-icon>
          </v-btn>
        </v-flex>
        <v-flex class="text-right">
          <v-chip class="primary px-10 controlled-font" controlled-font
            >{{ questionDetails.questionNumber }}/{{ totalQuestions }}</v-chip
          >
        </v-flex>
      </v-layout>
    </div>
    <div v-else>
      <p class="controlled-font">
        {{ siteText.ui.practiceTestComplete }}
      </p>
      <v-layout>
        <v-flex sm3>
          <v-btn
            class="primary white--text controlled-font"
            @click="onStartTest"
          >
            {{ siteText.ui.startTest }}
            <v-icon right>
              mdi-arrow-right-bold
            </v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </div>
  </v-container>
</template>

<script>
import generalApi from "../api/generalApi";
import appTestQuestion from "../components/TestQuestion.vue";
import { mapActions } from "vuex";
import { mapGetters } from "vuex";

import * as consts from "../store/constants";
export default {
  components: {
    appTestQuestion,
  },
  async mounted() {
    this.questionNumber = 1;
    await this.getPracticeTest();
  },
  data() {
    return {
      practiceTest: null,
      questionNumber: 1,
      selectedAnswer: "",
      practiceTestComplete: false,
    };
  },
  methods: {
    ...mapActions([
      "setBusy",
      "clearBusy",
      "SetPage",
      "setTestStage",
      "setTermsAgreed",
    ]),
    async getPracticeTest() {
      this.setBusy();
      this.practiceTest = await generalApi.getPracticeTest(
        this.testAttemptDetails.testAttemptId,
        this.selectedLocaleId
      );
      console.log(this.practiceTest);
      this.clearBusy();
    },
    onAnswerChanged(answer) {
      this.selectedAnswer = answer;
      if (this.displayAlert) {
        if (this.questionNumber === this.practiceTest.questions.length) {
          this.practiceTestComplete = true;
        } else {
          ++this.questionNumber;
        }
      }
    },
    onPreviousQuestion() {
      --this.questionNumber;
    },
    onNextQuestion() {
      ++this.questionNumber;
      if (this.questionNumber > this.practiceTest.questions.length) {
        this.practiceTestComplete = true;
      }
    },
    onStartTest() {
      this.setTermsAgreed(false);
      this.setTestStage(consts.TEST_STAGES.TERMS);
      this.SetPage(this.pages.Test.name);
    },
  },
  computed: {
    ...mapGetters([
      "selectedLocaleId",
      "screenMessages",
      "siteText",
      "pages",
      "testAttemptDetails",
    ]),
    questionDetails() {
      let question = {};
      if (this.practiceTest && this.practiceTest.questions) {
        question = this.practiceTest.questions.find(
          (q) => q.questionNumber === this.questionNumber
        );
        console.log(question);
      }
      return question;
    },
    totalQuestions() {
      return this.practiceTest && this.practiceTest.questions
        ? this.practiceTest.questions.length
        : 0;
    },
    messageText() {
      return "";
    },
    displayAlert() {
      return this.practiceTest && this.practiceTest.showAlert;
    },
    firstQuestion() {
      return this.questionNumber === 1;
    },
    lastQuestion() {
      return (
        this.practiceTest &&
        this.practiceTest.questions &&
        this.questionNumber > this.practiceTest.questions.length
      );
    },
    showSkipQuestion() {
      return false;
    },
    answerRequired() {
      return this.selectedAnswer === "";
    },
  },
  watch: {
    async selectedLocaleId(newValue, oldValue) {
      if (newValue != oldValue) {
        await this.getPracticeTest();
      }
    },
  },
};
</script>

<style scoped></style>
